import React from "react";
import "./style.scss";

const DelayMarkingButton = (props) => {
  const { handleClick, isCardBtn } = props;

  return (
    <div>
      <button
        className={`${
          isCardBtn ? "card-delay-marking-btn" : "delay-marking-btn px-3 py-2"
        }`}
        onClick={handleClick}
      >
        Mark Delay
      </button>
    </div>
  );
};

export default DelayMarkingButton;
